<template>
  <div>
    <p class="p-1" :data-e2e="AICypressAttribute.views.CLARA_FOR_PLANNERS_WELCOME">
      {{ welcomeMessage }}
    </p>

    <p class="p-1">{{ $t('ai.clara-for-planners.welcome-body') }}</p>

    <div
      v-if="questions.length"
      class="is-flex is-flex-direction-column is-align-items-flex-start has-gap-8 m-t-16"
      :data-e2e="AICypressAttribute.views.CLARA_FOR_PLANNERS_SEEDED_QUESTIONS"
    >
      <p class="is-uppercase is-size-6 has-text-weight-semibold has-text-grey">
        {{ $t('ai.clara-for-planners.recent-questions-label') }}
      </p>

      <ButtonView
        v-for="(question, index) in questions"
        :key="index"
        type="is-primary"
        outlined
        class="clara-seeded-question is-justify-content-flex-start has-text-left p-y-8 has-text-weight-semibold"
        :data-e2e="`${AICypressAttribute.buttons.CLARA_FOR_PLANNERS_SEEDED_QUESTION_}${index}`"
        @click="$emit('question-selected', question)"
      >
        {{ question }}
      </ButtonView>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';

export default defineComponent({
  name: 'ClaraForPlannersWelcome',
  emits: ['question-selected'],
  components: {
    ButtonView
  },
  props: {
    welcomeMessage: {
      type: String as PropType<string>,
      required: true
    },
    questions: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    }
  },
  static: {
    AICypressAttribute
  }
});
</script>

<style scoped>
.clara-seeded-question {
  height: auto;
  min-height: var(--ce-40px);
  white-space: normal;
}
</style>
